import React, { useState, useEffect } from 'react';
import api from '../api/client';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box', outline: 'none', display: 'block' };
const btnPrimary = { padding: '9px 20px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 14, cursor: 'pointer' };
const btnGhost = { padding: '8px 16px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '8px 16px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function Settings() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ name: '', password: '', anthropic_api_key: '' });
  const [showKey, setShowKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    const { data } = await api.get('/settings');
    setSettings(data);
    setForm(f => ({ ...f, name: data.name || '' }));
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setMsg(''); setError('');
    setLoading(true);
    try {
      const payload = {};
      if (form.name) payload.name = form.name;
      if (form.password) payload.password = form.password;
      if (form.anthropic_api_key) payload.anthropic_api_key = form.anthropic_api_key;
      await api.put('/settings', payload);
      setMsg('✅ Настройки сохранены');
      setForm(f => ({ ...f, password: '', anthropic_api_key: '' }));
      await load();
    } catch (e) { setError(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const deleteKey = async () => {
    if (!window.confirm('Удалить API ключ? Будет использоваться системный ключ.')) return;
    await api.delete('/settings/api-key');
    setMsg('✅ API ключ удалён');
    await load();
  };

  if (!settings) return <div style={{ padding: 40, color: '#aaa' }}>Загрузка...</div>;

  return (
    <div style={{ padding: 32, maxWidth: 560 }}>
      <h1 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 8px' }}>Настройки</h1>
      <div style={{ fontSize: 13, color: '#888', marginBottom: 28 }}>
        {settings.email} · {settings.role === 'owner' ? 'Владелец' : 'Менеджер'}
      </div>

      {/* Профиль */}
      <div style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: 20, marginBottom: 20 }}>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 16 }}>Профиль</div>
        <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Имя</label>
        <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} placeholder="Ваше имя" />
        <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Новый пароль</label>
        <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} style={inp} placeholder="Оставьте пустым чтобы не менять" />
      </div>

      {/* API ключ Claude */}
      <div style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: 20, marginBottom: 20 }}>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>API ключ Anthropic (Claude)</div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>
          Получите ключ на{' '}
          <a href="https://console.anthropic.com/settings/keys" target="_blank" rel="noreferrer" style={{ color: '#534AB7' }}>
            console.anthropic.com
          </a>.
          Если не указан — используется системный ключ.
        </div>

        {settings.has_api_key ? (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 13, color: '#27ae60', marginBottom: 8 }}>
              ✅ API ключ установлен: <code style={{ background: '#f0f0ee', padding: '2px 6px', borderRadius: 4 }}>{settings.api_key_preview}</code>
            </div>
            <button onClick={deleteKey} style={btnDanger}>🗑 Удалить ключ</button>
          </div>
        ) : (
          <div style={{ fontSize: 13, color: '#e67e22', marginBottom: 12 }}>
            ⚠️ Личный ключ не установлен — используется системный
          </div>
        )}

        <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>
          {settings.has_api_key ? 'Заменить ключ' : 'Добавить ключ'}
        </label>
        <div style={{ position: 'relative' }}>
          <input
            type={showKey ? 'text' : 'password'}
            value={form.anthropic_api_key}
            onChange={e => setForm(f => ({ ...f, anthropic_api_key: e.target.value }))}
            style={{ ...inp, marginBottom: 0, paddingRight: 42 }}
            placeholder="sk-ant-api03-..."
          />
          <button onClick={() => setShowKey(s => !s)}
            style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#888' }}>
            {showKey ? '🙈' : '👁'}
          </button>
        </div>
        {form.anthropic_api_key && !form.anthropic_api_key.startsWith('sk-ant-') && (
          <div style={{ fontSize: 12, color: '#c0392b', marginTop: 4 }}>⚠️ Ключ должен начинаться с sk-ant-</div>
        )}
      </div>

      {msg && <div style={{ color: '#27ae60', fontSize: 13, marginBottom: 12 }}>{msg}</div>}
      {error && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>{error}</div>}

      <button onClick={save} disabled={loading} style={btnPrimary}>
        {loading ? 'Сохраняем...' : 'Сохранить изменения'}
      </button>
    </div>
  );
}
